import React from 'react'
import { uniq } from 'lodash'

const Pagination = ({ currentPage, onPageChange, numberOfItems, pageLength }) => {
  // Always show the current page
  let pages = [currentPage]
  // Calculate the number of pages based on page length
  const numberOfPages = Math.ceil(numberOfItems / pageLength)

  // Simplify pagination if there are not a lot of elements (under 10 pages)
  const simplifyPagination = numberOfPages <= 10

  // Generate the page numbers
  if (simplifyPagination) {
    // Create pages when under 10 pages
    pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].filter(page => page <= numberOfPages)
  } else {
    for (const interval of [1, 2, 10, 25, 100, 1000, 10000]) {
      const mod = currentPage % interval
      // Generate the lower bound for this current interval
      const lower = mod ? currentPage - mod : currentPage - interval
      // Generate the upper bound for this current interval
      const upper = mod ? currentPage - mod + interval : currentPage + interval

      if (lower > 0) pages.unshift(lower)
      if (upper <= numberOfPages) pages.push(upper)
    }
  }

  // Wrapper to avoid too much code repetition
  const pageChangeWrapper = (content, newPage) => (
    <li className="page-item">
      <button className="page-link" onClick={() => onPageChange(newPage)}>
        {content}
      </button>
    </li>
  )

  // Buttons to go to first and last pages, show only when at least 2 from the first or last page.
  const goToStart = currentPage > 2 && pageChangeWrapper(<i className="fas fa-angle-double-left"></i>, 1)
  const goToEnd = currentPage < numberOfPages - 1 && pageChangeWrapper(<i className="fas fa-angle-double-right"></i>, numberOfPages)

  // Buttons to go to next or previous page, show only when not at first or last page.
  const nextPage = currentPage < numberOfPages && pageChangeWrapper(<i className="fas fa-angle-right"></i>, currentPage + 1)
  const prevPage = currentPage > 1 && pageChangeWrapper(<i className="fas fa-angle-left"></i>, currentPage - 1)

  return (
    <nav aria-label="Page navigation example">
      <ul className="pagination">
        {!simplifyPagination && (
          <>
            {goToStart}
            {prevPage}
          </>
        )}
        {/* Remove duplicate page numbers */}
        {uniq(pages).map((page, index) => {
          return (
            <li key={index} className={`page-item ${page === currentPage && 'active'}`}>
              <button className="page-link" onClick={() => onPageChange(page)}>
                {page}
              </button>
            </li>
          )
        })}
        {!simplifyPagination && (
          <>
            {nextPage}
            {goToEnd}
          </>
        )}
      </ul>
    </nav>
  )
}

export default Pagination

Pagination.defaultProps = {
  pageLength: 10
}
